import { collection, doc, getDoc, getDocs, query, setDoc, where } from 'firebase/firestore'

import { db } from 'utils/firebase'

import { Program, ProgramType } from 'types/program'
import { Data } from 'types/query'

import { formatDocSnapshot, formatQuerySnapshot } from './formatFirestoreResults'

export const fetchGroupById = async (groupId: string | undefined): Promise<Program | null> => {
  if (!groupId) return null
  const groupRef = doc(db, 'programs', groupId)
  const groupDocSnap = await getDoc(groupRef)
  return formatDocSnapshot(groupDocSnap) as unknown as Program
}

export const fetchGroupsByIds = async (groupIds: string[]) => {
  const groupPromises = groupIds.map((id) => fetchGroupById(id))
  const groups = await Promise.all(groupPromises)
  return groups?.filter((p) => p?.type !== ProgramType.PROGRAM)
}

export const fetchGroupByUserId = async (data: Data): Promise<Program | null> => {
  const { userId } = data
  if (!userId) return null

  const q = query(collection(db, 'programs'), where('trainer.id', '==', userId))
  const querySnapshot = await getDocs(q)
  const groups = formatQuerySnapshot(querySnapshot)
  const actualGroups = groups?.filter((p) => p?.type !== ProgramType.PROGRAM)
  if (actualGroups.length === 0) return null
  return actualGroups[0]
}

export const postGroup = async (data: Data) => {
  if (!data || !data?.groupId || !data?.updatedOrCreatedData)
    throw new Error('No data passed into postGroup')

  const { groupId, updatedOrCreatedData } = data
  const groupRef = doc(db, 'programs', groupId)

  const fullData = { ...updatedOrCreatedData, updated: new Date() }
  await setDoc(groupRef, fullData, { merge: true })
  return fullData
}
